import { render, staticRenderFns } from "./DialogContent.vue?vue&type=template&id=16bfa933&scoped=true"
import script from "./DialogContent.vue?vue&type=script&lang=ts"
export * from "./DialogContent.vue?vue&type=script&lang=ts"
import style0 from "./DialogContent.vue?vue&type=style&index=0&id=16bfa933&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfa933",
  null
  
)

export default component.exports